export const CLP_FORMATTER = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP",
  maximumFractionDigits: 0,
});

export const formatCLP = (value) => CLP_FORMATTER.format(Number(value || 0));

export const parseFormattedAmount = (value) => {
  if (typeof value === "number") return value;
  if (typeof value !== "string") return 0;
  return Number(value.replace(/[^0-9]/g, "")) || 0;
};

export const sumCartItems = (items = []) =>
  items.reduce((acc, item) => acc + Number(item.price || 0) * Number(item.quantity || 0), 0);